import React, { useEffect } from 'react';
import { Formik } from 'formik';
import Upload from '../../../components/form/Upload';
import InputField from '../../../components/form/InputField';
import { connect } from 'react-redux';
import {
  createArtisanCategoryAction,
  updateArtisanCategoryAction,
  getArtisanCategoriesAction,
  getArtisanParentCategoriesAction
} from '../../../modules/artisanJobCategories/Actions';
import {
  artisanCategoriesIsLoadingSelector,
  artisanCategoryByIdSelector,
  artisanParentCategoriesAsValueAndLabel
} from '../../../modules/artisanJobCategories/Selectors';
import FormGroup from '../../../components/form/FormGroup';
import FormBIOi18n from '../../../components/form/i18nForm/FormBIOi18n';

import { FormattedMessage, injectIntl } from 'react-intl';
import * as Yup from 'yup';
import { CheckBox, SearchableSelect, TextArea } from '../../../components/form';
import getLangData from '../../../utils/getLangData';

const schema = () =>
  Yup.object().shape({
    name: Yup.string()
      .required(getLangData().fields.required)
      .default(''),
    categoryImage: Yup.string()
      .required(getLangData().fields.required)
      .default('https://images.unsplash.com/photo-1487180144351-b8472da7d491?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1352&q=80'),
    namei18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default('')
    }),
    description: Yup.string()
      .required(getLangData().fields.required)
      .default(''),
    descriptioni18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default('')
    }),
    featured: Yup.boolean().default(false),
    // parentId: Yup.string()
    //   .default('')
    //   .nullable()
  });
const profileLang = getLangData().profile_types;
const fieldsLang = getLangData().fields;
const buttonsLang = getLangData().buttons;
const ArtisanCategoriesForm = props => {
  const {
    categoryId,
    isLoading,
    createArtisanCategory,
    updateArtisanCategory,
    getArtisanCategories,
    artisanCategory,
    getParentCategoires,
    artisanParentCategories
  } = props;
  useEffect(() => {
    if (categoryId && !artisanCategory) {
      getArtisanCategories();
    }
  }, [getArtisanCategories, categoryId, artisanCategory]);
  const parentLabel =
    artisanCategory &&
    typeof artisanCategory.parentId === 'string' &&
    artisanParentCategories.find(el => el._id === artisanCategory.parentId)
      ?.name;

  return (
    <Formik
      enableReinitialize
      validationSchema={schema()}
      initialValues={artisanCategory ? { ...artisanCategory } : schema().cast()}
      onSubmit={values => {
        const data = values;
        data.type = '1';
        if (categoryId) {
          if (values.parentId) {
            updateArtisanCategory(categoryId, {
              parentId: !values.parentId._id
                ? values.parentId
                : values.parentId._id,
              ...data
            });
          } else {
            updateArtisanCategory(categoryId, data);
          }
        } else {
          if (values.parentId) {
            createArtisanCategory({
              parentId: !values.parentId._id
                ? values.parentId
                : values.parentId._id,
              ...data
            });
          } else {
            delete data.parentId;
            createArtisanCategory(data);
          }
        }
      }}
    >
      {({ handleSubmit, values, errors }) => (
        <FormGroup
          handleSubmit={handleSubmit}
          isLoading={isLoading}
          errors={errors}
          // heading={
          //   artisanCategory
          //     ? `Update [${artisanCategory.name}]`
          //     : 'Create Artisan Category'
          // }
          heading={
            artisanCategory
              ? `${buttonsLang.update} ${artisanCategory.name}`
              : buttonsLang.create
          }
        >
          <InputField label={fieldsLang.name} name='name' />
          {/* <FormBIOi18n name='namei18n' description={fieldsLang.name} /> */}
          <TextArea label={fieldsLang.descrition} name='description' />
          {/* <FormBIOi18n
            name='descriptioni18n'
            description={fieldsLang.descrition}
          /> */}
          {/* <SearchableSelect
            name='parentId'
            label={fieldsLang.parent + ' (Optional)'}
            getItems={getParentCategoires}
            isLoading={isLoading}
            options={artisanParentCategories}
            getOptionLabel={artisanParentCategories}
            placeholder={parentLabel}
          /> */}

          <Upload
            data={{ artisanID: 'category' }}
            name='categoryImage'
            label={fieldsLang.image}
            S3Bucket='warshatna-artisans'
            // API="customer/customer-category-image-signedurl/"
            API='artisan/artisan-category-signedurl/'
          />
          <CheckBox name='featured' label={fieldsLang.featured} />
        </FormGroup>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const categoryId = props.match.params.id;
  return {
    categoryId,
    isLoading: artisanCategoriesIsLoadingSelector(state),
    artisanCategory: artisanCategoryByIdSelector(state, categoryId),
    artisanParentCategories: artisanParentCategoriesAsValueAndLabel(state)
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    getArtisanCategories: getArtisanCategoriesAction,
    createArtisanCategory: createArtisanCategoryAction,
    updateArtisanCategory: updateArtisanCategoryAction,
    getParentCategoires: getArtisanParentCategoriesAction
  })(ArtisanCategoriesForm)
);
